import React from 'react';
import {
    withStyles,
    Grid, 
    ButtonBase,
    Typography, 
    Modal,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"


import AppUtils from '../../control/apputlis';
 
const ICON_CLOSE = require("../../images/icons/guanbi.png");
const ICON_BG = require("../../images/bg/party-popper.png");
const ICON_MASK = require('../../images/bg/mask.png');


class IntegralSign extends React.Component {


    constructor(props) {
        super(props); 
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'IntegralSign');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }


    render() {
        const { classes, open, score } = this.props;

        return (
            <Modal
                open={open}
                hideBackdrop={true}
                onClose={() => this.props.onClose()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className={classes.modal}
                style={{ position: 'fixed', top: 0, width: '100vw' }}
            >
                <Grid container direction='column' alignItems='center' justify='center' className={classes.root}>
                    <Grid container direction='column' alignItems='center' className={classes.container}>
                        <img src={ICON_BG} style={{ width: 125, height: 125, marginTop: -62.5 }} />
                        <Grid container direction='column' alignItems='center' justify='center' style={{ marginTop: 12 }}>
                            <Typography style={{ fontSize: 20, color: '#0D0D0D' }}>恭喜您签到成功</Typography>
                        </Grid>
                        <Grid container direction='row' alignItems='baseline' justify='center' >
                            <Typography style={{ fontSize: 13, color: '#0D0D0D' }}>获得</Typography>
                            <Typography style={{ fontSize: 50, color: '#F91B1B', marginLeft: 8, marginRight: 8 }}>{score}</Typography>
                            <Typography style={{ fontSize: 13, color: '#0D0D0D' }}>积分</Typography>
                        </Grid>
                        <Grid style={{ marginTop: 12 }}>
                            <ButtonBase onClick={() => this.props.onClose()} className={classes.button}>查看可兑换商品</ButtonBase>
                        </Grid>
                    </Grid>
                    <Grid style={{ marginTop: 32 }}>
                        <ButtonBase onClick={() => this.props.onClose()}>
                            <img src={ICON_CLOSE} style={{ width: 32, height: 32 }}></img>
                        </ButtonBase>
                    </Grid>
                </Grid>
            </Modal>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    modal: {
        backgroundColor: 'transparent',
        width: '100vw',
        height: '100vh',
    },
    root: { 
        backgroundImage: `url(${ICON_MASK})`,
        width: '100vw',
        height: '100vh',
    },
    container: {
        width: 270,
        height: 254,
        backgroundColor: '#FFF',
        borderRadius: 20
    },
    button: {
        backgroundColor: '#F8D40A',
        width: 210,
        height: 40,
        borderRadius: 20,
        color: '#986008'
    }
}))(IntegralSign));